/*eslint-disable*/
import axios from 'axios';
import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import styled from 'styled-components';

const Container = styled.div`
  min-height: 100vh;
  background: #f5f7fa;
  padding: 30px;

  @media (max-width: 768px) {
    padding: 15px;
  }
`;

const Header = styled.div`
  background: white;
  border-radius: 12px;
  padding: 30px;
  margin-bottom: 30px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  gap: 20px;

  h1 {
    color: #333;
    font-size: 32px;
    font-weight: 600;
    margin: 0;
  }
`;

const HeaderActions = styled.div`
  display: flex;
  gap: 12px;
  align-items: center;
`;

const SearchInput = styled.input`
  padding: 10px 16px;
  border: 2px solid #e0e0e0;
  border-radius: 8px;
  font-size: 14px;
  width: 300px;
  transition: border-color 0.3s;

  &:focus {
    outline: none;
    border-color: #667eea;
  }
`;

const RefreshButton = styled.button`
  padding: 10px 20px;
  background: #667eea;
  color: white;
  border: none;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: background 0.3s;

  &:hover:not(:disabled) {
    background: #5568d3;
  }

  &:disabled {
    background: #ccc;
    cursor: not-allowed;
  }
`;

const Content = styled.div`
  background: white;
  border-radius: 12px;
  padding: 30px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
`;

const TableContainer = styled.div`
  overflow-x: auto;
`;

const Table = styled.table`
  width: 100%;
  border-collapse: collapse;
  margin-bottom: 20px;

  thead {
    background: #f8f9fa;
  }

  th {
    padding: 16px;
    text-align: left;
    font-weight: 600;
    color: #555;
    border-bottom: 2px solid #e0e0e0;
    font-size: 14px;
  }

  td {
    padding: 16px;
    border-bottom: 1px solid #f0f0f0;
    color: #333;
    font-size: 14px;
  }

  tbody tr:hover {
    background: #f8f9fa;
  }
`;

const SortableTh = styled.th`
  cursor: pointer;
  user-select: none;
  white-space: nowrap;

  &:hover {
    background: #eef0f3;
  }
`;

const NoData = styled.td`
  text-align: center;
  color: #999;
  padding: 40px !important;
  font-style: italic;
`;

const StatusBadge = styled.span`
  display: inline-block;
  padding: 6px 12px;
  border-radius: 20px;
  font-size: 12px;
  font-weight: 500;
  background: ${props => props.status === 'approved' ? '#d4edda' : props.status === 'disapproved' ? '#fff3cd' : '#f8d7da'};
  color: ${props => props.status === 'approved' ? '#155724' : props.status === 'disapproved' ? '#856404' : '#721c24'};
`;

const TypeBadge = styled.span`
  display: inline-block;
  padding: 4px 10px;
  border-radius: 20px;
  font-size: 12px;
  font-weight: 500;
  background: ${props => props.type === 'free' ? '#d1ecf1' : '#e2d9f3'};
  color: ${props => props.type === 'free' ? '#0c5460' : '#4a2080'};
`;

const DetailButton = styled.button`
  padding: 6px 14px;
  background: #667eea;
  color: white;
  border: none;
  border-radius: 6px;
  font-size: 13px;
  cursor: pointer;
  white-space: nowrap;

  &:hover {
    background: #5568d3;
  }
`;

const StatusSelect = styled.select`
  padding: 6px 10px;
  border: 1px solid #ccc;
  border-radius: 6px;
  font-size: 13px;
  cursor: pointer;
`;

const StatusChangeButton = styled.button`
  padding: 6px 14px;
  background: #667eea;
  color: white;
  border: none;
  border-radius: 6px;
  font-size: 13px;
  cursor: pointer;

  &:hover:not(:disabled) {
    background: #5568d3;
  }

  &:disabled {
    background: #ccc;
    cursor: not-allowed;
  }
`;

const TableInfo = styled.div`
  padding-top: 20px;
  border-top: 1px solid #e0e0e0;
  color: #666;
  font-size: 14px;

  strong {
    color: #333;
    font-size: 16px;
  }
`;

const KeywordList = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 4px;
`;

const Keyword = styled.span`
  background: #e9ecef;
  color: #495057;
  padding: 2px 8px;
  border-radius: 12px;
  font-size: 12px;
`;

/* 모달 */
const Overlay = styled.div`
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.6);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
  padding: 20px;
`;

const Modal = styled.div`
  background: white;
  border-radius: 12px;
  width: 100%;
  max-width: 640px;
  max-height: 90vh;
  overflow-y: auto;
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.3);
`;

const ModalHeader = styled.div`
  padding: 24px 24px 0;
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 12px;
`;

const ModalTitle = styled.h2`
  margin: 0;
  font-size: 20px;
  color: #333;
`;

const CloseButton = styled.button`
  background: none;
  border: none;
  font-size: 24px;
  cursor: pointer;
  color: #888;
  line-height: 1;
  padding: 0;
  flex-shrink: 0;

  &:hover {
    color: #333;
  }
`;

const ModalBody = styled.div`
  padding: 20px 24px 24px;
`;

const Thumbnail = styled.img`
  width: 100%;
  border-radius: 8px;
  margin-bottom: 16px;
  object-fit: cover;
  max-height: 300px;
`;

const ModalRow = styled.div`
  display: flex;
  gap: 8px;
  margin-bottom: 12px;
  font-size: 14px;
  align-items: flex-start;

  label {
    font-weight: 600;
    color: #555;
    min-width: 90px;
    flex-shrink: 0;
  }

  span {
    color: #333;
    line-height: 1.5;
  }
`;

function ExtensionList() {
  const [extensions, setExtensions] = useState([]);
  const [loading, setLoading] = useState(false);
  const [searchTerm, setSearchTerm] = useState('');
  const [sortKey, setSortKey] = useState('created_at');
  const [sortDir, setSortDir] = useState('desc');
  const [selected, setSelected] = useState(null);
  const [statusValue, setStatusValue] = useState('');
  const [statusUpdating, setStatusUpdating] = useState(false);
  const navigate = useNavigate();

  const token = useSelector((state) => state.auth.token);

  useEffect(() => {
    if (!token) navigate('/login');
  }, [token, navigate]);

  const fetchExtensions = async () => {
    if (!token) return;
    try {
      setLoading(true);
      const res = await axios.get(`${process.env.REACT_APP_API_URL}/extension`, {
        headers: { 'access-token': token }
      });
      const data = Array.isArray(res.data) ? res.data
        : Array.isArray(res.data?.data) ? res.data.data : [];
      setExtensions(data);
    } catch (error) {
      console.error('익스텐션 조회 실패:', error);
      if (error?.response?.status === 401) {
        navigate('/login');
      } else {
        alert(error?.response?.data?.detail || '익스텐션 목록을 불러오는데 실패했습니다.');
      }
    } finally {
      setLoading(false);
    }
  };

  const handleStatusChange = async () => {
    if (!selected || statusValue === selected.status) return;
    try {
      setStatusUpdating(true);
      await axios.put(
        `${process.env.REACT_APP_API_URL}/extension/${selected.id}/status`,
        { before: selected.status, after: statusValue },
        { headers: { 'access-token': token } }
      );
      alert('익스텐션 상태가 변경되었습니다.');
      setSelected(null);
      fetchExtensions();
    } catch (error) {
      console.error('상태 변경 실패:', error);
      alert(error?.response?.data?.detail || '상태 변경에 실패했습니다.');
    } finally {
      setStatusUpdating(false);
    }
  };

  useEffect(() => {
    if (token) fetchExtensions();
  }, [token]);

  useEffect(() => {
    if (selected) setStatusValue(selected.status);
  }, [selected]);

  const formatDate = (dateString) => {
    if (!dateString) return '-';
    return new Date(dateString).toLocaleDateString('ko-KR', {
      year: 'numeric', month: '2-digit', day: '2-digit'
    });
  };

  const getStatusText = (status) => {
    if (status === 'approved') return '승인';
    if (status === 'disapproved') return '미승인';
    if (status === 'deleted') return '삭제';
    return status ?? '-';
  };

  const getTypeText = (type) => {
    if (type === 'free') return '무료';
    if (type === 'premium') return '프리미엄';
    if (type === 'popup') return '팝업';
    if (type === 'floating') return '플로팅 버튼';
    if (type === 'rolling_banner') return '롤링 배너';
    return type ?? '-';
  };

  const handleSort = (key) => {
    if (sortKey === key) {
      setSortDir(d => d === 'asc' ? 'desc' : 'asc');
    } else {
      setSortKey(key);
      setSortDir('asc');
    }
  };

  const sortIcon = (key) => {
    if (sortKey !== key) return ' ↕';
    return sortDir === 'asc' ? ' ↑' : ' ↓';
  };

  const filtered = extensions
    .filter(ext =>
      (ext.title && ext.title.toLowerCase().includes(searchTerm.toLowerCase())) ||
      (ext.keyword && ext.keyword.some(k => k.toLowerCase().includes(searchTerm.toLowerCase())))
    )
    .sort((a, b) => {
      let aVal = a[sortKey] ?? '';
      let bVal = b[sortKey] ?? '';
      if (sortKey === 'created_at' || sortKey === 'updated_at') {
        aVal = aVal ? new Date(aVal).getTime() : 0;
        bVal = bVal ? new Date(bVal).getTime() : 0;
      } else {
        aVal = String(aVal).toLowerCase();
        bVal = String(bVal).toLowerCase();
      }
      if (aVal < bVal) return sortDir === 'asc' ? -1 : 1;
      if (aVal > bVal) return sortDir === 'asc' ? 1 : -1;
      return 0;
    });

  return (
    <Container>
      <Header>
        <h1>익스텐션 리스트</h1>
        <HeaderActions>
          <SearchInput
            type="text"
            placeholder="제목 또는 키워드로 검색..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
          />
          <RefreshButton onClick={fetchExtensions} disabled={loading}>
            {loading ? '새로고침 중...' : '새로고침'}
          </RefreshButton>
        </HeaderActions>
      </Header>

      <Content>
        <TableContainer>
          <Table>
            <thead>
              <tr>
                <th>ID</th>
                <SortableTh onClick={() => handleSort('title')}>제목{sortIcon('title')}</SortableTh>
                <SortableTh onClick={() => handleSort('extension_type')}>타입{sortIcon('extension_type')}</SortableTh>
                <th>키워드</th>
                <SortableTh onClick={() => handleSort('status')}>상태{sortIcon('status')}</SortableTh>
                <SortableTh onClick={() => handleSort('created_at')}>등록일{sortIcon('created_at')}</SortableTh>
                <SortableTh onClick={() => handleSort('updated_at')}>수정일{sortIcon('updated_at')}</SortableTh>
                <th>상세</th>
              </tr>
            </thead>
            <tbody>
              {filtered.length === 0 ? (
                <tr>
                  <NoData colSpan="8">
                    {searchTerm ? '검색 결과가 없습니다.' : '익스텐션 데이터가 없습니다.'}
                  </NoData>
                </tr>
              ) : (
                filtered.map((ext) => (
                  <tr key={ext.id}>
                    <td>{ext.id}</td>
                    <td>{ext.title || '-'}</td>
                    <td><TypeBadge type={ext.extension_type}>{getTypeText(ext.extension_type)}</TypeBadge></td>
                    <td>
                      <KeywordList>
                        {ext.keyword?.length > 0
                          ? ext.keyword.map((k, i) => <Keyword key={i}>{k}</Keyword>)
                          : '-'}
                      </KeywordList>
                    </td>
                    <td><StatusBadge status={ext.status}>{getStatusText(ext.status)}</StatusBadge></td>
                    <td>{formatDate(ext.created_at)}</td>
                    <td>{formatDate(ext.updated_at)}</td>
                    <td>
                      <DetailButton onClick={() => setSelected(ext)}>상세보기</DetailButton>
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </Table>
        </TableContainer>

        <TableInfo>
          <p>총 익스텐션 수: <strong>{filtered.length}개</strong></p>
        </TableInfo>
      </Content>

      {selected && (
        <Overlay onClick={() => setSelected(null)}>
          <Modal onClick={(e) => e.stopPropagation()}>
            <ModalHeader>
              <ModalTitle>{selected.title}</ModalTitle>
              <CloseButton onClick={() => setSelected(null)}>×</CloseButton>
            </ModalHeader>
            <ModalBody>
              {selected.thumbnail_url && (
                <Thumbnail src={selected.thumbnail_url} alt={selected.title} />
              )}
              <ModalRow>
                <label>ID</label>
                <span>{selected.id}</span>
              </ModalRow>
              <ModalRow>
                <label>타입</label>
                <span><TypeBadge type={selected.extension_type}>{getTypeText(selected.extension_type)}</TypeBadge></span>
              </ModalRow>
              <ModalRow>
                <label>상태</label>
                <span><StatusBadge status={selected.status}>{getStatusText(selected.status)}</StatusBadge></span>
              </ModalRow>
              <ModalRow>
                <label>상태 변경</label>
                <span style={{ display: 'flex', gap: '8px', alignItems: 'center' }}>
                  <StatusSelect value={statusValue} onChange={(e) => setStatusValue(e.target.value)}>
                    <option value="approved">승인</option>
                    <option value="disapproved">미승인</option>
                    <option value="deleted">삭제</option>
                  </StatusSelect>
                  <StatusChangeButton
                    onClick={handleStatusChange}
                    disabled={statusUpdating || statusValue === selected.status}
                  >
                    {statusUpdating ? '변경 중...' : '변경'}
                  </StatusChangeButton>
                </span>
              </ModalRow>
              <ModalRow>
                <label>키워드</label>
                <span>
                  <KeywordList>
                    {selected.keyword?.length > 0
                      ? selected.keyword.map((k, i) => <Keyword key={i}>{k}</Keyword>)
                      : '-'}
                  </KeywordList>
                </span>
              </ModalRow>
              <ModalRow>
                <label>내용</label>
                <span>{selected.content || '-'}</span>
              </ModalRow>
              <ModalRow>
                <label>등록일</label>
                <span>{formatDate(selected.created_at)}</span>
              </ModalRow>
              <ModalRow>
                <label>수정일</label>
                <span>{formatDate(selected.updated_at)}</span>
              </ModalRow>
            </ModalBody>
          </Modal>
        </Overlay>
      )}
    </Container>
  );
}

export default ExtensionList;
